define('controllers/members',['require','johngrid','daterangepicker'],function(require) {
    var CreateJohnGrid = require('johngrid');
    require('daterangepicker');
	return function() {
		var btnSearch = null;

		$(function () {
			//vacations
			btnSearch = $("#btnSearch");
			var vacationTable = CreateJohnGrid(),
				tblVacations = $("#tblVacations");

			vacationTable.showTopRow = false;
			vacationTable.init(tblVacations);

			//main pr grid
			var tblPRMembers = $("#tblPRMembers"),
				table = CreateJohnGrid(),
				columns = [{ DataField: "First" }, { DataField: "Last" }, { DataField: "Email" }, { DataField: "Employer" },
						   { DataField: "Testimonial" }, { DataField: "InterviewNotes" },
						   { DataField: "VacationCount", HeaderText: "Vacations&nbsp;(<span id='averageVacCount'></span>)" }, { DataField: "EstAnnualSavings", HeaderText: "Est.&nbsp;Annual&nbsp;Savings&nbsp;(<span id='averageEstAnnualSavings'></span>)" },
						   { DataField: "SignedUp" }, { DataField: "Linked" },
						   { DataField: "Phone" }, { DataField: "Phone2" }, { DataField: "DOB" }, { DataField: "Address1" }, { DataField: "Address2" },
						   { DataField: "City" }, { DataField: "StateProv" }, { DataField: "PostalCode" }],
				headerTemplate = $("#headerTemplate"),
				txtEmail = $("#txtEmail"),
				txtLN = $("#txtLN"),
				txtFN = $("#txtFN"),
				txtEmployer = $("#txtEmployer"),
				txtState = $("#txtState"),
				chkLinked = $("#chkLinked"),
				chkBooked = $("#chkBooked"),
				ddlTake = $("#ddlTake"),
				AJAXURL = "PRMembersAJAX.aspx";

			table.sorting.allowSorting = true;
			table.showTopRow = false;
			table.editHelpers.init($("#editTemplate"));
			table.pkColumnName = "id";
			table.init(tblPRMembers, columns, AJAXURL);

			btnSearch.on('click', function () {
				table.databind();
				tblPRMembers.show().parent().show();
				table.editHelpers.$editTemplate.hide();
			});
			table.onDataBinding = function () {
				btnSearch.hide().next().show();

				table.dsPostValues.Email = txtEmail.val();
				table.dsPostValues.First = txtFN.val();
				table.dsPostValues.Last = txtLN.val();
				table.dsPostValues.Employer = txtEmployer.val();
				table.dsPostValues.State = txtState.val();
				table.dsPostValues.Linked = chkLinked.is(":checked");
				table.dsPostValues.Booked = chkBooked.is(":checked");
			};

			table.onCreatingRows = function () {
				$("#averageVacCount").text(table.currentDataSource.averageVacCount);
				$("#averageEstAnnualSavings").text(table.currentDataSource.averageEstAnnualSavings);
				table.currentDataSource = table.currentDataSource.results;
			};

			table.onDataBound = function () {
				$("#spnResultCount").text(table.currentDataSource.length + " Results");
				btnSearch.show().next().hide();
			};

			table.utilities.onSwapped = function () {
				tblPRMembers.css("display") == "none" ? tblPRMembers.parent().hide() : tblPRMembers.parent().show();
			};

			table.editHelpers.onEdit = function (item) {
				var vacations = item.vacations == null ? [] : item.vacations;
				vacationTable.databind(vacations);
			};

			$("#btnClear").on("click", function () { clearForm(headerTemplate); });
			function clearForm(context) {
				$("input:not(input[type='button'], input[type='checkbox'], input[type='radio'])", context).val("");
				$("input[type='checkbox'], input[type='radio']", context).prop('checked', false);
				$("select option", context).first().prop("selected", true);
				$("textarea", context).val("");
			}

			//ability to filter by daterange...
			var dateFormat = "MM/dd/yyyy", //"ddd MMM dd yyyy",
				today = new Date().toString(dateFormat),
				separator = " - ",
				rangePickerOptions = {
					opens: 'left',
					separator: separator,
					format: dateFormat, // hh:mm '
					ranges: {
						'Today': ['today', 'today'],
						'Yesterday': ['yesterday', 'yesterday'],
						'Last 7 Days': [Date.today().add({ days: -6 }), 'today'],
						'Last 30 Days': [Date.today().add({ days: -29 }), 'today'],
						'This Month': [Date.today().moveToFirstDayOfMonth(), Date.today()], // no need to call .moveToLastDayOfMonth() in this application...
						'Last Month': [Date.today().moveToFirstDayOfMonth().add({ months: -1 }), Date.today().moveToFirstDayOfMonth().add({ days: -1 })],
						'This Year': [Date.parse("1/1/" + Date.today().getFullYear()), Date.today()],
						'All Time': [Date.parse("7/29/2010"), Date.today()]
					},
					locale: {}
				};

			rangePickerOptions.locale.fromLabel = "From";
			rangePickerOptions.locale.toLabel = "To";

			var qsFrom = requestQueryString("From"),
				qsTo = requestQueryString("To");

			table.dsPostValues.Fromdate = qsFrom == "" ? today : qsFrom;
			table.dsPostValues.ToDate = qsTo == "" ? today : qsTo;

			$("#txtCreated")
				.val(table.dsPostValues.Fromdate + separator + table.dsPostValues.ToDate)
				.daterangepicker(rangePickerOptions,
					function (start, end) { //when date range changes...
						table.dsPostValues.Fromdate = start.toString(dateFormat);
						table.dsPostValues.ToDate = end.toString(dateFormat);
					});

			if (window.ServerData.feData.searchEmployer) {
                btnSearch.trigger('click');
            }

			Utilities.setDefaultButton(headerTemplate, btnSearch);
			txtEmail.focus();
		});
	};
});
